import { NavigationItem } from './types'

export const getIsActiveNavItem = (item: NavigationItem, currentPathname?: string, currentScreen?: string) => {
  const isActivePath =
    item.activePathnames &&
    currentPathname &&
    item.activePathnames.some((activePath) => {
      return currentPathname.includes(activePath)
    })
  const isActiveScreen =
    item.activeScreens &&
    currentScreen &&
    item.activeScreens.some((activePath) => {
      return currentScreen.includes(activePath)
    })
  return Boolean(isActivePath || isActiveScreen)
}
